module.exports = __webpack_public_path__ + "static/ithor-basketball-19d598fd4bfe5c5f666efcbd2e89d5c6.gif";